module.exports = __webpack_public_path__ + "static/img/fz_fz_tb.d791c29.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_fz_tb.png
// module id = GAj7
// module chunks = 0